import { render, staticRenderFns } from "./ThirdAdminComp.vue?vue&type=template&id=3bb70b8c&scoped=true&"
import script from "./ThirdAdminComp.vue?vue&type=script&lang=js&"
export * from "./ThirdAdminComp.vue?vue&type=script&lang=js&"
import style0 from "./ThirdAdminComp.vue?vue&type=style&index=0&id=3bb70b8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb70b8c",
  null
  
)

export default component.exports